import {Component, EventEmitter, Output} from '@angular/core';
import {AQH_HOR_1, AQH_HOR_4} from '../../../../../../@shared/models/input.module';
import {Horses} from '../../../../../../@shared/services/horses';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-horse',
  standalone: false,
  templateUrl: './add-horse.html',
  styleUrl: './add-horse.css'
})
export class AddHorse {
  horseRegistries = [
    { label: 'AQHA', value: 0 },
    { label: 'APHA', value: 1 },
    { label: 'ApHC', value: 2 },
    { label: 'Other', value: 3 },
  ]

  horseGenders = [
    { label: 'Gelding', value: 0 },
    { label: 'Stallion', value: 1 },
    { label: 'Mare', value: 2 },
  ]

  name = '';
  date_of_birth = '';            // input type="date" gives 'YYYY-MM-DD'
  passport_id = '';
  breed = '';
  color = '';
  vaccination_date = '';
  next_vaccination_date = '';

  selectedRegistry: any = null;
  selectedGender: any = null;

  horseImageFile: File | null = null;
  pedigreeFile: File | null = null;
  vaccinationCardFile: File | null = null;


  constructor(private horseService: Horses,
              private modal: NgbActiveModal) {
  }

  private toISO(date: string): string {
    if (!date) return '';
    // Handle full ISO strings (2025-10-12T00:00:00.000Z)
    if (date.includes('T')) {
      return date.split('T')[0]; // → "2025-10-12"
    }
    // Already YYYY-MM-DD (from input type="date")
    return date;
  }

  onSave() {
    const payload: AQH_HOR_1 = {
      name: this.name.trim(),
      date_of_birth: this.toISO(this.date_of_birth),
      passport_id: this.passport_id.trim(),
      horse_registry_id: this.selectedRegistry?.value ?? 0,
      gender: this.selectedGender[0],
      breed: this.breed.trim(),
      color: this.color.trim(),
      vaccination_date: this.toISO(this.vaccination_date),
      next_vaccination_date: this.toISO(this.next_vaccination_date),
      owner_name: "",
      owner_phone_number: "",
      image_url: '',
      pedigree_image_url: '',
      vaccination_card_url: '',
    };

    this.horseService.postHorse(payload).subscribe((res) => {
      console.log('Horse added:', res);
      let horse = res;
      if (this.horseImageFile) {
        let payload: AQH_HOR_4 = {
          horse_id: res.horse_id,
          image_type: 'horse_image',
          image: this.horseImageFile
        }
        this.horseService.uploadHorseImage(payload).subscribe((res) => {
          console.log('Horse image uploaded:', res)
          horse = res
        });
      }
      if (this.pedigreeFile) {
        let payload: AQH_HOR_4 = {
          horse_id: res.horse_id,
          image_type: 'pedigree_image',
          image: this.pedigreeFile
        }
        this.horseService.uploadHorseImage(payload).subscribe((res) => {
          console.log('Pedigree image uploaded:', res)
          horse = res
        });
      }
      if (this.vaccinationCardFile) {
        let payload: AQH_HOR_4 = {
          horse_id: res.horse_id,
          image_type: 'vaccination_image',
          image: this.vaccinationCardFile
        }
        this.horseService.uploadHorseImage(payload).subscribe((res) => {
          console.log('Vaccination image uploaded:', res)
          horse = res
        });
      }
      console.log('Last response', horse);
      this.modal.close(true);
    })
  }

  close() {
    this.modal.close();
  }


}
